import app from '../../app';
import * as queries from './queries';

export async function loadQuestionnaireQRCodeToken({ dispatch }, {
  chosenSubjectId,
  chosenVersionNumber,
  chosenLocale,
  chosenUsername,
  chosenBeforeAfter,
  initializer
}) {
    return app.apolloClient
    .query({
      query: queries.createTabletUrlForStartingASession,
      variables: {
        subjectId: chosenSubjectId,
        version: chosenVersionNumber,
        locale: chosenLocale,
        userName: chosenUsername ? chosenUsername : '',
        afterMeeting: chosenBeforeAfter === 'after',
        initializer : initializer
      },
    })
    .then((result) => {
      return result.data.createTabletUrlForStartingASession
    })
}